import { withProps } from 'recompose';
import { FieldArray } from 'redux-form';
import TypedCollectionInner from './TypedCollectionInner';

const TypedCollection = withProps({
    component: TypedCollectionInner,
})(FieldArray);

export default TypedCollection;
